import { env } from '../env';

class RedirectUtils {
  constructor() { }
  redirecionarParaEcontador() {
    window.location = `//${env.econtadorFront}`;
  }
}

export const redirectUtils = new RedirectUtils()